var CodingRates;
(function (CodingRates) {
    CodingRates["CODINGRATE_4_5"] = "4/5";
    CodingRates["CODINGRATE_4_6"] = "4/6";
    CodingRates["CODINGRATE_4_7"] = "4/7";
    CodingRates["CODINGRATE_4_8"] = "4/8";
})(CodingRates || (CodingRates = {}));
export default CodingRates;
